import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["playlists"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setAlert } from 'actions/alerts';
function useUpdatePlaylistsDistributions(_ref) {
  var playlists = _ref.playlists,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function updateDistributions(_x) {
    return _updateDistributions.apply(this, arguments);
  }
  function _updateDistributions() {
    _updateDistributions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var _ref2$domainsToAdd, domainsToAdd, _ref2$domainsToRemove, domainsToRemove, promises, domainIdsToAdd, addArray, domainIdsToRemove, deleteIds;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref2$domainsToAdd = _ref2.domainsToAdd, domainsToAdd = _ref2$domainsToAdd === void 0 ? [] : _ref2$domainsToAdd, _ref2$domainsToRemove = _ref2.domainsToRemove, domainsToRemove = _ref2$domainsToRemove === void 0 ? [] : _ref2$domainsToRemove;
            promises = [];
            if (domainsToAdd.length > 0) {
              domainIdsToAdd = domainsToAdd.map(function (_ref3) {
                var id = _ref3.id;
                return id;
              }); // This is a filtered list of the playlists which as yet dont have the domains defined
              addArray = playlists.flatMap(function (playlist) {
                return domainIdsToAdd
                // Filter out those that already exist for the domain
                .filter(function (domainId) {
                  return !playlist.domains.some(function (domain) {
                    return Number(domain.id) === domainId;
                  });
                }).map(function (domainId) {
                  return {
                    asset_id: playlist.id,
                    target_domain_id: domainId
                  };
                });
              });
              if (addArray.length > 0) {
                promises.push(api('post', '/api/query/assetDomains/', {
                  fields: ['id', 'asset_id', 'target_domain_id']
                }, addArray));
              }
            }
            if (domainsToRemove.length > 0) {
              domainIdsToRemove = domainsToRemove.map(function (_ref4) {
                var id = _ref4.id;
                return +id;
              }); // Create a list of the AssetDomain ID's to delete
              deleteIds = playlists.flatMap(function (playlist) {
                return playlist.domains.filter(function (domain) {
                  return domainIdsToRemove.includes(+domain.id);
                }).map(function (_ref5) {
                  var assetDomainId = _ref5.assetDomainId;
                  return +assetDomainId;
                }).filter(Boolean);
              });
              if (deleteIds.length > 0) {
                promises.push(api('delete', '/api/query/assetDomains/', {
                  filter: {
                    id: deleteIds
                  }
                }));
              }
            }
            return _context.abrupt("return", Promise.all(promises));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updateDistributions.apply(this, arguments);
  }
  var _useMutation = useMutation(updateDistributions, _objectSpread(_objectSpread({}, options), {}, {
      onError: function onError() {
        setAlert({
          key: 'playlist-access-error',
          title: t('alert_playlist_distribution_update_error', {
            count: playlists.length
          })
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    updatePlaylistsDistributions: mutateAsync
  });
}
export default useUpdatePlaylistsDistributions;